import CoreLayout from './CoreLayoutContainer'

export default CoreLayout
